module.exports = __webpack_public_path__ + "media/configurations/ZOC_X-X-O-86353aa8.png";